<template>
  <md-field :class="[
                {'md-error': errors.has('qaCategoryId')},
                {'md-valid': !errors.has('qaCategoryId') && touched.qaCategoryId}]" >
    <md-select
      v-model="qaCategoryId"
      data-vv-name="qaCategoryId"
      v-validate= "modelValidations.qaCategoryId">
      <md-option v-for="item in listData" :value="item.id" :key="item.id">{{item.name}}</md-option>
    </md-select>
    <slide-y-up-transition>
      <div class="vErrorText" v-show="errors.has('qaCategoryId')">【必須】必ず一つ選択してください</div>
    </slide-y-up-transition>
    <slide-y-down-transition>
      <md-icon class="error" v-show="errors.has('qaCategoryId')" style="margin-right:20px">close</md-icon>
    </slide-y-down-transition>
    <slide-y-down-transition>
      <md-icon class="success" v-show="!errors.has('qaCategoryId') && touched.qaCategoryId" style="margin-right:20px">done</md-icon>
    </slide-y-down-transition>
  </md-field>
</template>
<script>
  import NestedValidator from '../../mixins/nested-validator'
  export default {
    inject: ['$validator'],
    mixins: [NestedValidator],
    data() {
      return {
        listData: [],
        modelValidations: {
          qaCategoryId: {
            required: true
          }
        },
        touched: {
          qaCategoryId: false,
        },
      }
    },
    model: {
    },
    props:  ['value','noSelectFlag','touchedFlag'],    // undefinedはfalse扱い
    methods: {
      getCategories () {
        this.axios({
          method  : 'GET',
          url     : this.AdminApiUrl + '/qa_categories/select_list',
          timeout : 10000,
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          this.createList(response.data)
          sessionStorage.setItem('qaCategorySelect', JSON.stringify(response.data))
        })
        .catch(error => {
          this.dangerNotify('QAカテゴリリストを取得できませんでした')
        })
      },
      createList (obj) {
        if (this.noSelectFlag) {
          var item = {
            id: '選択しない',
            name: '選択しない',
          }
          this.listData.push(item)
          this.qaCategoryId = '選択しない'
        }
        for (var i in obj) {
          var item = {
            id: obj[i].id,
            name: obj[i].name
          }
          this.listData.push(item)
        }
      },
      setCategory () {
        var qaCategorySelect = sessionStorage.getItem('qaCategorySelect')
        if (qaCategorySelect === null) {
          this.getCategories()
        } else {
          qaCategorySelect = JSON.parse(qaCategorySelect)
          this.createList(qaCategorySelect)
        }
      }
    },
    mounted () {
      this.setCategory()
      this.touched.qaCategoryId = false
    },watch: {
      qaCategoryId(){
        this.touched.qaCategoryId = this.touchedFlag
      },
      '$route.path'(value){
        if (value.match('new')) {
          this.$validator.reset()
          this.touched.qaCategoryId = false 
        }
      }
    },computed: {
      qaCategoryId: {
        get: function() {
          return this.value;
        },
        set: function(newValue) {
          this.$emit('input', newValue)
        }
      }
    }

  }
</script>
<style scoped>
.categorySelect{
  width: 100%;
}
</style>